"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SearchPagination = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _uxcore = require("@ux/uxcore2");

var _constants = require("../constants");

var _app = require("../store/reducers/app");

var _searchResults = require("../store/reducers/searchResults");

var _actions = require("../store/actions");

var _styles = _interopRequireDefault(require("../styles"));

var _Style = _interopRequireDefault(require("./Style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SearchPagination =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SearchPagination, _PureComponent);

  function SearchPagination(props) {
    var _this;

    _classCallCheck(this, SearchPagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchPagination).call(this, props));
    _this.handleClickBack = _this.handleClickBack.bind(_assertThisInitialized(_this));
    _this.handleClickForward = _this.handleClickForward.bind(_assertThisInitialized(_this));
    _this.leftArrow = _this.leftArrow.bind(_assertThisInitialized(_this));
    _this.rightArrow = _this.rightArrow.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchPagination, [{
    key: "leftArrow",
    value: function leftArrow() {
      return _react.default.createElement("div", {
        className: "help--search-pagination-nav-arrow help--search-pagination-nav-arrow-left",
        onClick: this.handleClickBack,
        onKeyDown: null,
        role: "button",
        tabIndex: 0
      }, _react.default.createElement(_uxcore.Icon, {
        name: "chevron-left-lt",
        size: 18,
        color: _styles.default.colors.grayMedium
      }));
    }
  }, {
    key: "rightArrow",
    value: function rightArrow() {
      return _react.default.createElement("div", {
        className: "help--search-pagination-nav-arrow help--search-pagination-nav-arrow-right",
        onClick: this.handleClickForward,
        onKeyDown: null,
        role: "button",
        tabIndex: 0
      }, _react.default.createElement(_uxcore.Icon, {
        name: "chevron-right-lt",
        size: 18,
        color: _styles.default.colors.grayMedium
      }));
    }
  }, {
    key: "handleClickBack",
    value: function () {
      var _handleClickBack = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this$props, searchPage, searchQuery, newPage;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, searchPage = _this$props.searchPage, searchQuery = _this$props.searchQuery;
                newPage = (parseInt(searchPage, 10) - 1).toString();
                this.fetch(newPage);
                this.props.history.push("/search/".concat(searchQuery, "/").concat(newPage));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleClickBack() {
        return _handleClickBack.apply(this, arguments);
      }

      return handleClickBack;
    }()
  }, {
    key: "handleClickForward",
    value: function () {
      var _handleClickForward = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this$props2, searchPage, searchQuery, newPage;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, searchPage = _this$props2.searchPage, searchQuery = _this$props2.searchQuery;
                newPage = (parseInt(searchPage, 10) + 1).toString();
                this.fetch(newPage);
                this.props.history.push("/search/".concat(searchQuery, "/").concat(newPage));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleClickForward() {
        return _handleClickForward.apply(this, arguments);
      }

      return handleClickForward;
    }()
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(searchPage) {
        var _this$props3, searchQuery, searchResults;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props3 = this.props, searchQuery = _this$props3.searchQuery, searchResults = _this$props3.searchResults;

                if (!(!searchResults || !searchResults[searchPage])) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return this.props.searchResultsGet({
                  query: searchQuery,
                  searchPage: searchPage
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          market = _this$props4.market,
          searchPage = _this$props4.searchPage,
          itemCount = _this$props4.itemCount;
      var itemsDisplayed = _constants.SEARCH_RESULTS_COUNT * parseInt(searchPage, 10);

      if (itemCount <= 0) {
        return null;
      }

      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "help--search-pagination-container"
      }, searchPage !== '1' && this.leftArrow(), searchPage === '1' && _react.default.createElement("div", null), _react.default.createElement("div", null, market === _constants.MARKET_EN_US && _react.default.createElement("span", null, "Page\xA0"), _react.default.createElement("span", null, searchPage)), itemsDisplayed < itemCount && this.rightArrow(), itemsDisplayed >= itemCount && _react.default.createElement("div", null)), _react.default.createElement(_Style.default, {
        css: "\n            .help--search-pagination-container {\n              display: flex;\n              justify-content: space-between;\n            }\n\n            .help--search-pagination-nav-arrow {\n              cursor: pointer;\n              outline: none;\n            }\n          "
      }));
    }
  }]);

  return SearchPagination;
}(_react.PureComponent);

exports.SearchPagination = SearchPagination;
SearchPagination.propTypes = {
  history: _propTypes.default.object.isRequired,
  itemCount: _propTypes.default.number,
  market: _app.appPropTypes.market,
  searchPage: _propTypes.default.string.isRequired,
  searchQuery: _propTypes.default.string.isRequired,
  searchResults: _searchResults.searchResultsPropType,
  searchResultsGet: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      page = _ownProps$match$param.page,
      query = _ownProps$match$param.query;
  return {
    itemCount: ownProps.itemCount,
    market: state.app.market,
    searchPage: page,
    searchQuery: query,
    searchResults: state.searchResults[query]
  };
};

var mapDispatchToProps = {
  searchResultsGet: _actions.searchResultsGet
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchPagination));

exports.default = _default;